import { AnimatePresence, m } from '@larvitu/shared/framer-motion/rsc';
import { varFade } from '@larvitu/shared/framer-motion/utils';
import { Box, Dialog, Paper } from '@mui/material';

import type { DialogProps } from '@mui/material';
import type { FC } from 'react';

export interface Props extends DialogProps {
  variants?: Record<string, unknown>;
  onClose?: VoidFunction;
}

export const DialogAnimate: FC<Props> = ({
  open = false,
  variants,
  onClose,
  children,
  sx,
  ...other
}) => (
  <AnimatePresence>
    {open && (
      <Dialog
        fullWidth
        disableEnforceFocus
        maxWidth="xs"
        open={open}
        onClose={onClose}
        PaperComponent={(props) => (
          <Box
            component={m.div}
            {...(variants
              || varFade( {
                distance: 120,
                durationIn: 0.32,
                durationOut: 0.24,
                easeIn: 'easeInOut',
              } ).inUp)}
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              onClick={onClose}
              sx={{ width: '100%', height: '100%', position: 'fixed' }}
            />
            <Paper sx={sx} {...props}>
              {props.children}
            </Paper>
            //{' '}
          </Box>
        )}
        {...other}
      >
        {children}
      </Dialog>
    )}
  </AnimatePresence>
);
